import React from "react";
import "./Contact.css";

export const ContactBanner = () => {
  return (
    <div className="aboutBanner">
      <div className="aboutContent">
        <div>Contact Us</div>
        <div>
          Practical renewable energy technology that reduces costs and helps the
          environment
        </div>
      </div>
    </div>
  );
};
